import { SCaseReducer } from './types';
import { SCustomer, SCustomerClient } from '../../types';
import { ObjectUtils } from '../../../../utils/util';
import { INITIAL_STATE } from '../../constants';

const loadCustomer: SCaseReducer<Partial<SCustomer>> = (state, action) => ({
  ...INITIAL_STATE.SCustomerReducer(),
  client: {
    ...INITIAL_STATE.SCustomerReducer().client,
    isEditFirstLoad: state.client.isEditFirstLoad,
    isBillEdit: state.client.isBillEdit,
    customerVerifyData: state.client.customerVerifyData,
  },
  customer: ObjectUtils.mergeObjectsWithDefaults(action.payload, INITIAL_STATE.SCustomer()),
});

const resetSlice: SCaseReducer<void> = (state) => {
  const preservedPaytmDevice = state.customer.selectedPaytmDevice;

  return {
    ...INITIAL_STATE.SCustomerReducer(),
    customer: {
      ...INITIAL_STATE.SCustomerReducer().customer,
      selectedPaytmDevice: preservedPaytmDevice, // keep old value
    },
  };
};

const updateCustomer: SCaseReducer<SCustomer> = (state, action) => {
  state.customer = action.payload;
};

const updateClient: SCaseReducer<Partial<SCustomerClient>> = (state, action) => {
  state.client = {
    ...state.client,
    ...action.payload,
  };
};

export default {
  loadCustomer,
  updateCustomer,
  resetSlice,
  updateClient,
};
